'use strict';

define(['app', '$window'], function (app, $window) {

  var responsiveFlyoutMenu = function responsiveFlyoutMenu() {
    var component = {};
    var _config = {
      attribs: {
        modClass: 'data-modifier-class',
        dropdownOpenOnClick: false,
        dropdownActive: 'data-js-dropdown-active',
        menuExpand: 'data-expand-class'
      },
      selectors: {
        menuStickyRow: '[data-js-element=responsiveFlyoutMenu_menuStickyRow]',
        menuButton: '[data-js-element=menuButton]',
        closeMenu: '[data-js-element=responsiveFlyoutMenu_closeMenu]',
        menuHome: '[data-js-element=responsiveFlyoutMenu_homeButton]',
        backToPrev: '[data-js-element=responsiveFlyoutMenu_backToPrev]',
        flyoutSlider: '[data-flyout]',
        subNav: '[data-js-element=subnav]',
        subNavLink: '[data-js-element=subnavLink]',
        subnavLinkSelector: '* > [data-js-element=subnavLink]',
        hasSubnav: '[data-js-element=hasSubnav]',
        menuUnderlay: '[data-js-element=menuUnderlay]',
        mobileUnderlay: '[data-js-element=smallMenuUnderlay]',
        levelTwoContainer: '.responsiveFlyoutMenu_levelTwo',
        cardsLevelContainer: '.responsiveFlyoutMenu_levelTwoInner-cards'
      },
      classNames: {
        popUpLock: 'js-popup-lock',
        slideTransform: 'responsiveFlyoutMenu_transform',
        homeButtonShow: 'responsiveFlyoutMenu_menuHomeButton-show',
        backButtonShow: 'responsiveFlyoutMenu_menuBackButton-show',
        stickyMenuShadow: 'responsiveFlyoutMenu_menuStickyRow-shadow',
        menuUnderlayClass: 'responsiveFlyoutMenu_menuUnderlay-show',
        dynamicDropdownClass: 'responsiveFlyoutMenu_levelOneItem-dynamic',
        landingPageLink: 'responsiveFlyoutMenu_levelTwoLandingPageLink',
        dropdownShow: 'active'
      }
    };

    var _init = function _init(element) {
      component.element = element;

      if ('ontouchstart' in document.documentElement) {
        component.config.attribs.dropdownOpenOnClick = true;
      }

      component.mobileNavMenuStatus = 'close';
      component.menuStickyRow = component.element.querySelector(component.config.selectors.menuStickyRow);
      component.menuButton = component.element.querySelector(component.config.selectors.menuButton);
      component.closeMenu = component.element.querySelector(component.config.selectors.closeMenu);
      component.menuShow = component.menuButton.getAttribute(component.config.attribs.modClass);
      component.flyoutSlides = component.element.querySelectorAll(component.config.selectors.flyoutSlider);
      component.subNav = component.element.querySelectorAll(component.config.selectors.subNav);
      component.subNavLink = component.element.querySelectorAll(component.config.selectors.subNavLink);
      component.menuHome = component.element.querySelector(component.config.selectors.menuHome);
      component.backToPrev = component.element.querySelector(component.config.selectors.backToPrev);
      component.hasSubnav = component.element.querySelectorAll(component.config.selectors.hasSubnav);
      component.menuUnderlay = document.querySelector(component.config.selectors.menuUnderlay);
      component.smallMenuUnderlay = component.element.querySelector(component.config.selectors.mobileUnderlay);
      component.levelTwoContainers = component.element.querySelectorAll(component.config.selectors.levelTwoContainer);
      component.cardsLevelContainers = component.element.querySelectorAll(component.config.selectors.cardsLevelContainer);
      component.headerBreakpoint = 1200;
      component.bind();
      component.equaliseCardHeights();

      return component;
    };

    var _bind = function _bind() {
      component.menuButton.addEventListener('click', component.open);
      component.closeMenu.addEventListener('click', component.close);
      component.smallMenuUnderlay.addEventListener('click', component.close);
      component.backToPrev.addEventListener('click', component.back);

      Array.from(component.flyoutSlides).map(function (el, index) {
        el.setAttribute('data-subnav-index', index);
        el.addEventListener('click', component.triggerSlide, false);
        if (index === component.flyoutSlides.length - 1) {
          component.allSubnavLinksFound = true;
        }
      });
      Array.from(component.flyoutSlides).map(function (el) {
        return el.addEventListener('scroll', component.addShadow, false);
      });
      Array.from(component.flyoutSlides).map(function (el) {
        return el.addEventListener('transitionend', component.removeShadow, false);
      });

      if (component.config.attribs.dropdownOpenOnClick) {
        //Add listener for removing underlay when tapping outside the menu items
        $window.addEventListener('click', function (e) {
          component.hideMenuUnderlay();
          if (component.config.attribs.lastDropdownOpened) {
            component.config.attribs.lastDropdownOpened.removeAttribute(component.config.attribs.dropdownActive);
          }
        });
        //Stop click through when tapping outside the menu when it's open
        component.menuUnderlay.addEventListener('click', component.handleMenuUnderlayEvent);
        //Fix tablet issue on scroll
        component.menuUnderlay.addEventListener('touchstart', function () {
          return setTimeout(component.handleMenuUnderlayEvent, 50);
        });

        Array.from(component.hasSubnav).map(function (el) {
          return el.addEventListener('click', component.handleTouch, false);
        });
      } else {
        Array.from(component.hasSubnav).map(function (el) {
          return el.addEventListener('mouseenter', function () {
            if (el.classList.contains(component.config.classNames.dynamicDropdownClass)) {
              el.classList.add(component.config.classNames.dropdownShow);
            }
            component.showMenuUnderlay();
          }, false);
        });
        Array.from(component.hasSubnav).map(function (el) {
          return el.addEventListener('mouseleave', function () {
            if (el.classList.contains(component.config.classNames.dynamicDropdownClass)) {
              el.classList.remove(component.config.classNames.dropdownShow);
            }
            component.hideMenuUnderlay();
          }, false);
        });
      }

      if (component.hasSubnav[0].classList.contains(component.config.classNames.dynamicDropdownClass)) {
        component.sizeDropdownMenu();
        $window.addEventListener('optimizedResize', component.sizeDropdownMenu, false);
      } else {
        $window.addEventListener('optimizedResize', component.resizeEvent, false);
      }

      _throttle('resize', 'optimizedResize');
    };

    var _handleTouch = function _handleTouch(e) {
      if (component.mobileNavMenuStatus === 'close') {
        if (component.config.attribs.lastDropdownOpened && component.config.attribs.lastDropdownOpened !== e.target) {
          component.config.attribs.lastDropdownOpened.removeAttribute(component.config.attribs.dropdownActive);
          component.config.attribs.lastDropdownOpened.parentNode.classList.remove(component.config.classNames.dropdownShow);
        }
        if (e.target.hasAttribute(component.config.attribs.dropdownActive)) {
          e.target.removeAttribute(component.config.attribs.dropdownActive);
          e.target.parentNode.classList.remove(component.config.classNames.dropdownShow);
          component.hideMenuUnderlay();
        } else {
          e.preventDefault();
          component.showMenuUnderlay();
          e.target.setAttribute(component.config.attribs.dropdownActive, '');
          if (e.target.parentNode.classList.contains(component.config.classNames.dynamicDropdownClass)) {
            e.target.parentNode.classList.add(component.config.classNames.dropdownShow);
          }
          component.config.attribs.lastDropdownOpened = e.target;
        }
      }
    };

    var _addShadow = function _addShadow(e) {
      var scrollPosition = e.target.scrollTop;
      if (scrollPosition > 5) {
        component.menuStickyRow.classList.add(component.config.classNames.stickyMenuShadow);
      } else {
        component.menuStickyRow.classList.remove(component.config.classNames.stickyMenuShadow);
      }
    };

    var _removeShadow = function _removeShadow() {
      component.menuStickyRow.classList.remove(component.config.classNames.stickyMenuShadow);
    };

    var _open = function _open() {
      component.prevScrollTop = $window.pageYOffset;
      component.menuButton.classList.add(component.menuShow);
      component.menuButton.parentElement.classList.add('responsiveFlyoutMenu-overlay');
      component.smallMenuUnderlay.classList.add(component.config.classNames.menuUnderlayClass);
      component.mobileNavMenuStatus = 'open';
      document.documentElement.classList.add(component.config.classNames.popUpLock);
      document.body.style.top = -component.prevScrollTop + 'px';

      app.publish('columbo/track', 'responsiveFlyoutMenu', 'open', 'mobile menu');
    };

    var _close = function _close() {
      component.menuButton.classList.remove(component.menuShow);
      component.menuButton.parentElement.classList.remove('responsiveFlyoutMenu-overlay');
      component.smallMenuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
      component.mobileNavMenuStatus = 'close';
      document.documentElement.classList.remove(component.config.classNames.popUpLock);
      document.body.style.top = '';
      app.element.scrollTo(component.prevScrollTop);
      component.resetMenu();

      app.publish('columbo/track', 'responsiveFlyoutMenu', 'close', 'mobile menu');
    };

    var _back = function _back() {
      var lastTransform = component.element.querySelectorAll('.' + component.config.classNames.slideTransform);
      if (lastTransform.length === 1) {
        component.backToPrev.classList.remove(component.config.classNames.backButtonShow);
        component.menuHome.classList.add(component.config.classNames.homeButtonShow);
      }

      lastTransform[lastTransform.length - 1].classList.remove(component.config.classNames.slideTransform);
      component.collapseMenu(lastTransform[lastTransform.length - 1].querySelectorAll(component.config.selectors.hasSubnav));
      Array.from(component.subNav).map(function (el) {
        return el.scrollTop = 0;
      });
    };

    var _resetMenu = function _resetMenu() {
      Array.from(component.flyoutSlides).map(function (el) {
        if (el.classList.contains(component.config.classNames.slideTransform)) {
          el.classList.remove(component.config.classNames.slideTransform);
        }
      });
      component.collapseMenu(component.hasSubnav);
      Array.from(component.subNav).map(function (el) {
        return el.scrollTop = 0;
      });
      component.backToPrev.classList.remove(component.config.classNames.backButtonShow);
      component.menuHome.classList.add(component.config.classNames.homeButtonShow);
    };

    var _showMenuUnderlay = function _showMenuUnderlay() {
      component.menuUnderlay.classList.add(component.config.classNames.menuUnderlayClass);
    };

    var _hideMenuUnderlay = function _hideMenuUnderlay() {
      component.menuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
    };

    var _findSubnavLink = function _findSubnavLink(el) {
      while (el.getAttribute('data-js-element') !== 'subnav') {
        if (el.getAttribute('data-js-element') === 'subnavLink') {
          break;
        }
        el = el.parentNode;
      }
      return el;
    };

    var _triggerSlide = function _triggerSlide(e) {
      var link = component.findSubnavLink(e.target);
      e.stopPropagation();

      if (link.getAttribute('data-js-element') !== 'subnavLink' || component.mobileNavMenuStatus === 'close') {
        return;
      }
      e.preventDefault();
      var modClass = void 0;

      component.modClass = link.getAttribute(component.config.attribs.menuExpand);

      if (component.allSubnavLinksFound) {
        var subNavIndex = e.currentTarget.getAttribute('data-subnav-index');
        var subnavLinks = component.subNav[subNavIndex].querySelectorAll(component.config.selectors.subnavLinkSelector);

        for (var i = 0; i < subnavLinks.length; i++) {
          var subnavlink = subnavLinks[i];
          if (subnavlink !== link) {
            modClass = subnavlink.getAttribute(component.config.attribs.menuExpand);
            subnavlink.classList.remove(modClass);
          }
        }

        link.classList.add(component.modClass);

        e.currentTarget.classList.add(component.config.classNames.slideTransform);
        component.backToPrev.classList.add(component.config.classNames.backButtonShow);
        component.menuHome.classList.remove(component.config.classNames.homeButtonShow);
      }
    };

    var _resizeEvent = function _resizeEvent() {
      if (component.getWindowWidth() > component.headerBreakpoint) {
        component.menuButton.classList.remove(component.menuShow);
        component.mobileNavMenuStatus = 'close';
        component.smallMenuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
        component.resetMenu();
      } else {
        component.menuUnderlay.classList.remove(component.config.classNames.menuUnderlayClass);
      }
    };

    var _getWindowWidth = function _getWindowWidth() {
      return $window.innerWidth;
    };

    var _throttle = function _throttle(type, name, comp) {
      comp = comp || $window;
      var running = false;
      var func = function func() {
        if (running) {
          return;
        }
        running = true;
        requestAnimationFrame(function () {
          comp.dispatchEvent(new CustomEvent(name));
          running = false;
        });
      };
      comp.addEventListener(type, func);
    };

    var _sizeDropdownMenu = function _sizeDropdownMenu() {
      var targetWidth = component.element.getBoundingClientRect().right - component.element.getBoundingClientRect().left;
      var headerMenuOffset = component.element.getBoundingClientRect().left;

      component.levelTwoContainers.forEach(function (level) {
        //first reset the left/right properties to the default values if resizing from mobile to desktop
        if (level.style.left === "100%") {
          level.style.left = 0;
          level.style.right = 'unset';
        }

        var levelWidth = level.getBoundingClientRect().right - level.getBoundingClientRect().left;
        var levelX = level.parentNode.getBoundingClientRect().left;
        var parentWidth = level.parentNode.getBoundingClientRect().right - level.parentNode.getBoundingClientRect().left;

        if (component.getWindowWidth() >= component.headerBreakpoint) {
          if (Math.abs(targetWidth - levelWidth) > 5) {
            level.style.left = 'auto';
            var screenOffset = levelX + levelWidth - targetWidth;
            var elementOffset = levelWidth / 2 - parentWidth / 2;
            var styleRightValue = elementOffset - screenOffset + headerMenuOffset;

            //Negative value means the menu overflows to the right to make it right align
            styleRightValue = styleRightValue < 0 ? 0 : styleRightValue;

            //Too large a value means the menu overflows to the left so make it left align
            if (levelWidth + styleRightValue > targetWidth) {
              level.style.left = 0;
              level.style.right = 'auto';
            } else {
              level.style.right = styleRightValue + 'px';
            }
          }
        } else {
          level.style.left = '100%';
          level.style.right = 0;
        }
      });

      component.resizeEvent();
    };

    var _handleMenuUnderlayEvent = function _handleMenuUnderlayEvent(e) {
      if (component.menuUnderlay.classList.contains(component.config.classNames.menuUnderlayClass)) {
        if (e && e.type === 'click') {
          e.preventDefault();
        }
        if (component.config.attribs.lastDropdownOpened) {
          component.config.attribs.lastDropdownOpened.removeAttribute(component.config.attribs.dropdownActive);
          component.hideMenuUnderlay();
        }
      }
    };

    var _equaliseCardHeights = function _equaliseCardHeights() {
      if (component.cardsLevelContainers.length > 0) {
        Array.from(component.cardsLevelContainers).map(function (el) {
          var cardsList = el.firstElementChild;

          var minHeight = -1;

          Array.from(cardsList.children).map(function (cardItem) {
            if (!cardItem.firstElementChild.classList.contains(component.config.classNames.landingPageLink)) {
              var currentHeight = window.getComputedStyle(cardItem.firstElementChild).getPropertyValue('height');
              var currentHeightValue = parseFloat(currentHeight.substring(0, currentHeight.indexOf("px")));

              if (currentHeightValue > minHeight) {
                minHeight = currentHeightValue;
              }
            }
          });

          if (minHeight > 0) {
            Array.from(cardsList.children).map(function (cardItem) {
              if (!cardItem.firstElementChild.classList.contains(component.config.classNames.landingPageLink)) {
                cardItem.firstElementChild.style.height = minHeight + "px";
              }
            });
          }
        });
      }
    };

    var _collapseMenu = function _collapseMenu(menus) {
      Array.from(menus).map(function (el) {
        if (el.firstElementChild.classList.contains(el.firstElementChild.getAttribute(component.config.attribs.menuExpand))) {
          el.firstElementChild.classList.remove(el.firstElementChild.getAttribute(component.config.attribs.menuExpand));
        }
      });
    };

    component.config = _config;
    component.init = _init;
    component.bind = _bind;
    component.findSubnavLink = _findSubnavLink;
    component.triggerSlide = _triggerSlide;
    component.open = _open;
    component.close = _close;
    component.back = _back;
    component.resetMenu = _resetMenu;
    component.showMenuUnderlay = _showMenuUnderlay;
    component.hideMenuUnderlay = _hideMenuUnderlay;
    component.resizeEvent = _resizeEvent;
    component.addShadow = _addShadow;
    component.removeShadow = _removeShadow;
    component.getWindowWidth = _getWindowWidth;
    component.sizeDropdownMenu = _sizeDropdownMenu;
    component.handleTouch = _handleTouch;
    component.handleMenuUnderlayEvent = _handleMenuUnderlayEvent;
    component.equaliseCardHeights = _equaliseCardHeights;
    component.collapseMenu = _collapseMenu;

    return component;
  };

  return responsiveFlyoutMenu;
});
//# sourceMappingURL=responsiveFlyoutMenu.js.map
